export const uhfFooterData = {
    components: [
      {
        data: [
          {
            type: 'image',
            id: 'mavcomlogo',
            imageUrl: 'https://a.staticaa.com/images/logo/mavcomlogo-en.png',
            redirectUrl: 'http://www.mavcom.my/en/consumer/make-a-complaint/',
            newTab: 'TRUE',
            altText: 'Mavcom Logo',
            direction: 'left',
          },
          {
            type: 'footer-notes',
            id: '',
            imageUrl: '',
            redirectUrl: '',
            newTab: '',
            altText: '',
            direction: '',
          },
          {
            type: 'image',
            id: 'awardimage',
            imageUrl: 'https://a.staticaa.com/images/logo/aa-logo.png',
            redirectUrl: 'https://www.airasia.com/',
            newTab: 'TRUE',
            altText: 'Airasia - 10 years success',
            direction: 'right',
          },
        ],
      },
    ],
    footerNotes: [
      {
        data: [
          {
            content:
              // eslint-disable-next-line max-len
              '©2020 AirAsia Group Berhad. Your usage of the AirAsia website indicates that you agree to be bound by our {0}, {1} and {2}.Fares include airport taxes and all applicable fees and charges imposed by the relevant regulatory bodies.This website is owned and operated by AirAsia Berhad (284669-W) (“AirAsia”). {3} {4} {5}',
            id: 'content1',
          },
          {
            content: '{0} | {1} | {2} | {3} | {4} | {5} | {6} | {7}',
            id: 'content2',
          },
        ],
      },
    ],
    content1: [
      {
        data: [
          {
            label: 'Terms and Conditions',
            url: 'https://www.airasia.com/my/en/about-us/terms-and-conditions.page',
            cnUrl: 'http://cms.airasia.com/my/en/about-us/terms-and-conditions.page',
            newTab: 'TRUE',
          },
          {
            label: 'Terms of Use',
            url: 'https://www.airasia.com/my/en/about-us/terms-of-use.page',
            cnUrl: 'https://www.airasia.com/aa/about-us/en/gb/terms-of-use-cn.html',
            newTab: 'TRUE',
          },
          {
            label: 'Privacy Statement',
            url: 'https://www.airasia.com/my/en/about-us/privacy-policy.page',
            cnUrl: 'http://cms.airasia.com/my/en/about-us/privacy-policy.page',
            newTab: 'TRUE',
          },
          {
            label: '亚航商务服务(广州)有限公司',
            url: 'https://www.airasia.com/zh/cn',
            cnUrl: '',
            newTab: 'TRUE',
          },
          {
            label: '粤ICP备17160544号-2',
            url: 'http://www.beian.miit.gov.cn/',
            cnUrl: '',
            newTab: 'TRUE',
          },
          {
            label: '证照信息',
            url: 'https://a.staticaa.com/pdf/business-license/wofe-business-license.pdf',
            cnUrl: '',
            newTab: 'TRUE',
          },
        ],
      },
    ],
    content2: [
      {
        data: [
          {
            label: 'AirAsia Berhad (Malaysia)',
            url: 'http://www.airasia.com/my/en/about-us/ir-organizational-structure.page',
            cnUrl: '',
            newTab: 'TRUE',
          },
          {
            label: 'Thai AirAsia Co. Ltd',
            url: 'http://www.aavplc.com/index.html?menu=aav_organisation_chart&lang=en',
            cnUrl: '',
            newTab: 'TRUE',
          },
          {
            label: 'PT Indonesia AirAsia',
            url: 'http://www.airasia.com/my/en/about-us/airasia-indonesia-organizational-structure.page',
            cnUrl: '',
            newTab: 'TRUE',
          },
          {
            label: 'Philippines AirAsia Inc.',
            url: 'http://www.airasia.com/my/en/about-us/airasia-philippine-organizational-structure.page',
            cnUrl: '',
            newTab: 'TRUE',
          },
          {
            label: 'AirAsia X Berhad (Malaysia)',
            url: 'http://www.airasiax.com/',
            cnUrl: '',
            newTab: 'TRUE',
          },
          {
            label: 'Thai AirAsia X Co.,Ltd ',
            url: 'http://www.airasia.com/my/en/about-us/thai-airasia-x-organizational-structure.page',
            cnUrl: '',
            newTab: 'TRUE',
          },
          {
            label: 'AirAsia Japan Co., Ltd.',
            url: 'http://www.airasia.com/jp/ja/about-us/airasia-japan-company-profile.page',
            cnUrl: '',
            newTab: 'TRUE',
          },
          {
            label: 'AirAsia (India) Limited',
            url: 'http://www.airasia.com/my/en/about-us/airasia-india-organizational-structure.page',
            cnUrl: '',
            newTab: 'TRUE',
          },
        ],
      },
    ],
  };